import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { search_filter } from '../../_model/search_fliter';
import { ConstantService } from './constant.service';
import { map, Observable, of } from 'rxjs';
import { filter_model } from '../../_model/fliter_model';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { from } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class DatasearchService {
  readonly ApiUrl: string = environment.appUrl;
  constructor(private http: HttpClient, public constants: ConstantService) { }

  // Get awards
  getAwards() {
    return this.http.get<any>(this.ApiUrl + '/get-awards');
  }

  // Get advisory
  getAdvisory() {
    return this.http.get<any>(this.ApiUrl + '/get-advisory-panel');
  }

  // Get events
  getEvents() {
    return this.http.get<any>(this.ApiUrl + '/get-events');
  }

  // Get events
  getClients() {
    return this.http.get<any>(this.ApiUrl + '/get-client');
  }
  // Get patends-india
  getPatents() {
    return this.http.get<any>(this.ApiUrl + '/get-patends-india');
  }
  // Get event details
  getEventDetails(id: number) {
    return this.http.get<any>(`${this.ApiUrl}/get-event-detail/${id}`);
  }

  // Get gallery
  getGallary() {
    return this.http.get<any>(this.ApiUrl + '/get-total-gallery');
  }

  // Get gallery details
  getGallaryDetails(id: string) {
    return this.http.get<any>(`${this.ApiUrl}/get-single-gallery-images/${id}`);
  }

  // Get Our Story
  getOurStory() {
    return this.http.get<any>(this.ApiUrl + '/get-stories');
  }
  // Get Our Story
  getPartners() {
    return this.http.get<any>(this.ApiUrl + '/get-partners');
  }

  // Get press releases
  getPressReleases() {
    return this.http.get<any>(this.ApiUrl + '/get-press-releases');
  }

  // Get press release details
  getPressReleasesDetails(id: string) {
    return this.http.get<any>(`${this.ApiUrl}/get-press-release-detail/${id}`);
  }

  // Get team members
  getAllHeadings() {
    return this.http.get<any>(this.ApiUrl + '/get-page-headers');
  }

  // Get team members
  getTeamMembers() {
    return this.http.get<any>(this.ApiUrl + '/get-team-members');
  }

  // // Get training videos
  getTrainingvideos() {
    return this.http.get<any>(this.ApiUrl + '/get-training-client');
  }

  // Get user profession
  getUserprofession() {
    return this.http.get<any>(
      'https://www.chemrobotics.com/staging/UserLoginController/get_scientific_professions'
    );
  }
  getPdfs() {
    return this.http.get<any>(this.ApiUrl + '/get-agro-service-pdf');
  }

  // Get user profile
  getUserprofile(postdata: any) {
    return this.http.post<any>(
      'https://www.chemrobotics.com/staging/UserLoginController/get_user_data',
      postdata
    );
  }
  // Post career forms
  postCareerAtforms(formData: FormData) {
    return this.http.post<any>(
      this.ApiUrl + '/submit-job-application',
      formData
    );
  }

  postFileUpdate(postdata: any) {
    return this.http.post<any>(this.ApiUrl + '/uploadfile', postdata);
  }
  postFileUpdate_careerat(postdata: any) {
    return this.http.post<any>(this.ApiUrl + '/uploadfile-careerat', postdata);
  }

  // Post career jobs
  getCareerAtjobs() {
    return this.http.get<any>(this.ApiUrl + '/get-job-client');
  }
  // get Regulatory service
  getRegulatoryservice() {
    return this.http.get<any>(this.ApiUrl + '/get-agro-regulatory');
  }
  // Send change password request
  sendChngepswd(postdata: any) {
    return this.http.post<any>(
      'https://www.chemrobotics.com/staging/UserLoginController/change_user_password',
      postdata
    );
  }

  // Send change password request
  sendResetpswd(formData: FormData) {
    return this.http.post<any>(
      'https://www.chemrobotics.com/staging//UserLoginController/reset_password',
      formData
    );
  }

  // Send change password request
  sendForgotpswd(formData: FormData) {
    return this.http.post<any>(
      'https://www.chemrobotics.com/staging//UserLoginController/forgot_password',
      formData
    );
  }

  // Send contact us request
  sendInquiryForm(postdata: any) {
    return this.http.post<any>(this.ApiUrl + '/user-query', postdata);
  }
  // Send demo request
  sendDemorequest(postdata: any) {
    return this.http.post<any>(this.ApiUrl + '/demo-request', postdata);
  }

  // Send signup request
  sendSignup(formData: FormData) {
    console.log(
      '<<<<<<<<<<<<<<<<<<<<<<<<<<<< formdata >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>',
      formData
    );
    return this.http.post<any>(
      'https://www.chemrobotics.com/staging/UserLoginController/register_new_user',
      formData
    );
    // return 1
  }

  // Send update request
  sendUpdate(postdata: any) {
    return this.http.post<any>(
      'https://www.chemrobotics.com/staging/UserLoginController/update_user_data',
      postdata
    );
  }
  // Post career jobs
  getFooter() {
    return this.http.get<any>(this.constants.ApiUrl + '/api/v2/footer');
  }
  // Post career jobs
  getHeader() {
    return this.http.get<any>(this.constants.ApiUrl + '/api/v2/header');
  }
  // Post career jobs
  getEthics() {
    return this.http.get<any>(this.ApiUrl + '/get-ethics');
  }
  // get about us
  getAboutus() {
    return this.http.get<any>(this.ApiUrl + '/get-about-us');
  }
  // get about us
  getBrochure() {
    return this.http.get<any>(this.constants.ApiUrl + '/api/v2/brochure');
  }
  getdropdown() {
    return this.http.get<any>(this.ApiUrl + '/api/v2/discovery-suite/columns');
  }
  get_suite_data(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/api/v2/discovery-suite/data',
      postdata
    );
  }
  discovery_suite_data_count(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/discovery-suite-data-count',
      postdata
    );
  }
  get_dynamic_feilds() {
    return this.http.get<any>(
      this.ApiUrl + '/api/v2/discovery-suite/dynamic-fields'
    );
  }
  getIpandLocation() {
    return this.http
      .get<any>('https://backend.chemrobotics.com/get-user-ip')
      .pipe(
        switchMap((res: any) => {
          const userIp = res.ip;

          return this.http.get<any>(`https://ipapi.co/${userIp}/json/`).pipe(
            map((location) => ({
              userip: userIp,
              address: location.city
                ? `${location.city}, ${location.region}, ${location.country_name}`
                : userIp,
            })),
            catchError(() => {
              return of({
                userip: userIp,
                address: userIp,
              });
            })
          );
        }),
        catchError(() => {
          // In case even IP fetch fails
          return of({
            userip: 'Unknown',
            address: 'Unknown',
          });
        })
      );
  }
  // Get quik patent datacount
  quik_patent_data_count(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/quik-patent-data-count',
      postdata
    );
  }
  get_discovery_suite_dropdown_values(postdata: any) {
    return this.http
      .post<filter_model[]>(
        this.constants.ApiUrl + '/api/v2/discovery-suite/suggestions-values',
        postdata
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  quik_patent_dropdown(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/api/v2/discovery-suite/suggestions-values',
      postdata
    );
  }
  quik_patent_data(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/api/v2/discovery-suite/quik-patent-data',
      postdata
    );
  }
  GetTemplateCols(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/api/v2/discovery-suite/dropdown-field-details',
      postdata
    );
  }
  GetTemplateColsForIpd() {
    return this.http.get<any>(
      this.constants.ApiUrl + '/api/v2/ipd/columns'
    );
  }
  userMasterManage(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl + '/usermaster_manage',
      postdata
    );
  }

  sendMail(postdata: any) {
    return this.http.post(this.constants.ApiUrl + '/sendmail', postdata);
  }
  sendMailNew(postdata: any) {
    return this.http.post(this.constants.ApiUrl + '/sendmail-new', postdata);
  }
  getKeywordList(searchQuery?: string) {
    // We send a POST request to the new filter endpoint
    // We set a high limit because the frontend needs all keywords for highlighting
    const payload = {
      limit: 10000,
      search: searchQuery || ''
    };
    return this.http.post<any>(
      this.constants.ApiUrl + '/api/v2/quikpatent/keywords/filter',
      payload
    );
  }
  // Demo Request
  demoRequest(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/demo-request',
      postdata
    );
  }

  //Get files base on GBRN (Data Availablity)
  dataAvailablity(gbrn: any) {
    return this.http.get<any>(
      this.constants.ApiUrl +
      '/api/v2/discovery-suite/data-availability/' +
      gbrn
    );
  }

  // Get page limit for database
  GetDatabasePageLimit(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl + '/api/v2/discovery-suite/user-page-limit',
      postdata
    );
  }
  //getplatform data of technical route
  getplatformdata(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl +
      '/api/v2/discovery-suite/technical-route-platform-data',
      postdata
    );
  }

  //getplatform fliters data of technical route
  getplatFormdataFilters(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl +
      '/api/v2/discovery-suite/technical-route-platform-filters',
      postdata
    );
  }

  //getplatform data of MRL
  getplatformmrldata(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl + '/api/v2/discovery-suite/mrl-data',
      postdata
    );
  }
  //getplatform data of  tabel header off MRL
  MRL_column_config() {
    return this.http.get<any>(
      this.constants.ApiUrl + '/api/v2/discovery-suite/mrl-columns'
    );
  }

  //mrl

  Mrl_Simple_data(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-mrl-data-simple',
      postdata
    );
  }
  Mrl_Advance_data(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-mrl-data-advance',
      postdata
    );
  }

  //quick-gapd
  save_mrl_columns(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/save-mrl-columns',
      postdata
    );
  }
  //Get Template Table Details
  GetTemplateTableDtls(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get_tabledtls_mongo',
      postdata
    );
  }

  quik_patent_types() {
    return this.http.get<any>(
      this.constants.ApiUrl + '/api/v2/discovery-suite/quik-patent-types'
    );
  }

  //patent countries
  getMrlUpdatesCountries() {
    return this.http.get<any>(
      this.constants.ApiUrl + '/get-mrlUpdates-countries'
    );
  }

  //gapd

  getGapdColumns() {
    return this.http.get<any>(
      this.constants.ApiUrl + '/api/v2/discovery-suite/gapd-columns'
    );
  }

  getplatforgapddata(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl + '/api/v2/discovery-suite/gapd-data',
      postdata
    );
  }

  getplatforimpddata(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl + '/api/v2/discovery-suite/imp-data',
      postdata
    );
  }

  getplatforimpuirtydata(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl + '/api/v2/discovery-suite/impurity-data',
      postdata
    );
  }

  //cipac database
  CIPAC_column_config() {
    return this.http.get<any>(
      `${this.constants.ApiUrl}/api/v2/discovery-suite/cipac-columns`
    );
  }

  getplatformcipacdata(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl + '/api/v2/discovery-suite/cipac-data',
      postdata
    );
  }

  // non-patent
  NON_PATENT_column_config() {
    return this.http.get<any>(
      `${this.constants.ApiUrl}/api/v2/discovery-suite/non-patent-columns`
    );
  }
  getplatformnonpatentdata(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl + '/api/v2/discovery-suite/non-patent-data',
      postdata
    );
  }

  //litigation
  getplatforlitigationddata(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl + '/api/v2/discovery-suite/litigation-data',
      postdata
    );
  }

  //scientific docs
  scientifc_docs_column_config() {
    return this.http.get<any>(
      `${this.constants.ApiUrl}/api/v2/discovery-suite/scientific-docs-columns`
    );
  }

  getplatforscientficdocsddata(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl + '/api/v2/discovery-suite/scientific-docs-data',
      postdata
    );
  }

  //spc database
  SPC_column_config() {
    return this.http.get<any>(
      `${this.constants.ApiUrl}/api/v2/discovery-suite/spc-columns`
    );
  }

  getplatforspcddata(postdata: any) {
    return this.http.post(
      this.constants.ApiUrl + '/api/v2/discovery-suite/spc-data',
      postdata
    );
  }

  //quik-patent
  save_quik_patent_column_config(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/api/v1/discovery-suite/save-quik-patent-columns',
      postdata
    );
  }

  quik_patent_column_config(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/api/v1/discovery-suite/quik-patent-columns',
      postdata
    );
  }
  getlabel(postdata: any) {
    return this.http.post<any>(this.constants.ApiUrl + '/get-label', postdata);
  }
  // Get combination dropdown values quik patent
  quik_patent_combination_dropdown(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/quik-patent-combination-dropdown-values',
      postdata
    );
  }
  quik_patent_analysis(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/api/v2/discovery-suite/quik-patent-analysis-data',
      postdata
    );
  }

  //ipd
  // Get dropdown values
  table_dropdown(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/table-dropdown',
      postdata
    );
  }

  // Get secondary table details
  get_secondary_table_details(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-secondary-table-detail',
      postdata
    );
  }

  // Get secondary table data
  get_secondary_table_data(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-secondary-table-data',
      postdata
    );
  }
  table_column_config() {
    return this.http.get<any>(
      this.constants.ApiUrl + '/api/v2/ipd/columns'
    );
  }
  save_table_column_config(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/table-column-config-save',
      postdata
    );
  }
  table_detail_view_template(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-table-detail-view',
      postdata
    );
  }
  table_data(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/api/v2/ipd/data',
      postdata
    );
  }
  getImagesBaseUrl() {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-images-base-url',
      {}
    );
  }

  // Get user accout type
  getUserAccountType(userId: string): Observable<any> {
    const localAccountType = localStorage.getItem('accountType') || 
                             localStorage.getItem('account_type') || 
                             (() => {
                               try {
                                 const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
                                 return currentUser.accountType || currentUser.account_type || '';
                               } catch (e) {
                                 return '';
                               }
                             })();
    return of({ account_type: localAccountType });
  }
  getcolumnsimpurity() {
    return this.http.get<any>(
      this.ApiUrl + '/api/v2/discovery-suite/impurity-columns'
    );
  }
  getcolumnslitigation() {
    return this.http.get<any>(
      this.ApiUrl + '/api/v2/discovery-suite/litigation-columns'
    );
  }
  getcolumnsscientificdocs() {
    return this.http.get<any>(
      this.ApiUrl + '/api/v2/discovery-suite/scientific-docs-columns'
    );
  }
  getcolumnstechnicalroute() {
    return this.http.get<any>(
      this.ApiUrl + '/api/v2/discovery-suite/technical-routes-columns'
    );
  }
  getcolumnsIMP() {
    return this.http.get<any>(
      this.ApiUrl + '/api/v2/discovery-suite/imp-routes-columns'
    );
  }

  generatePdf(postdata: any) {
    return this.http.post(
      this.ApiUrl + '/api/v2/discovery-suite/pdf/generate',
      postdata,
      {
        responseType: 'blob', // still blob
        observe: 'response', // returns HttpResponse<Blob>
      }
    );
  }


  //after change acc. to ipd news
  getNewsCatDetData(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-mrlUpdates-cat-det-open',
      postdata
    );
  }
  getMrlUpdatesData(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-mrlUpdates-data-open',
      postdata
    );
  }
  getNewsList(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-mrlUpdates-list-open',
      postdata
    );
  }

  // Get Recent MrlUpdates Open
  getRecentMrlUpdates(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-recent-mrlUpdates-open',
      postdata
    );
  }

  // Get MrlUpdates Category Details
  getNewsCategoryDetails(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-mrlUpdates-category-details',
      postdata
    );
  }
  // getNewsDetails(postdata: any) {
  //   return this.http.post<any>(
  //     this.constants.ApiUrl + '/get-mrlUpdates-details',
  //     postdata
  //   );
  // }

  // Get Related MrlUpdates
  getRelatedNews(postdata: any) {
    return this.http.post<any>(
      this.constants.ApiUrl + '/get-related-mrlUpdates',
      postdata
    );
  }

  getNewsData() {
    return this.http.get<any>(
      this.constants.ApiUrl + '/api/v2/news/public'
    );
  }

  getLatestNews(postdata: any) {
    return this.http.get<any>(`${this.constants.ApiUrl}/api/v2/news/public`, postdata);
  }


  getDatabaseNews(name: string) {
    return this.http.get<any>(`${this.constants.ApiUrl}/api/v2/news-databases/databases/${name}/news`);
  }

  getNewsDetails(newsId: string) {
    return this.http.get<any>(
      `${this.constants.ApiUrl}/api/v2/news/${newsId}`
    );
  }

  getDatabaseCategories(databaseName: string) {
    return this.http.get<any>(
      `${this.constants.ApiUrl}/api/v2/news/categories?databaseName=${databaseName}`
    )
  }

  getNewsByCategory(categoryId: any) {
    return this.http.get<any>(`${this.constants.ApiUrl}/api/v2/news-categories/${categoryId}/news`)
  }

  getNewsBySubcategory(id: string, page: number = 1, limit: number = 20, search: string = ''): Observable<any> {
    return this.http.get(`${this.constants.ApiUrl}/api/v2/news-subcategories/subcategory/${id}/news`, {
      params: {
        page: page.toString(),
        limit: limit.toString(),
        search
      }
    });
  }

  getCatSubcatTree(categoryId: string) {
    return this.http.get<any>(`${this.constants.ApiUrl}/api/v2/news-categories/with-subcategories`)
  }
}
